// File: src/components/pages/Payments.jsx
// Main payment management page with Collection and Approval tabs
// UPDATED: New Payment button moved to right side of status-tabs

import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { CreditCard, Plus } from 'lucide-react';
import CollectionForm from './payments/CollectionForm';
import ApprovalList from './payments/ApprovalList';
import { AUTH0_NAMESPACE } from '../../utils/constants';
import '../../styles/unified.css';

const Payments = () => {
  const { user } = useAuth0();
  const [activeTab, setActiveTab] = useState('collection');
  const [showCollectionForm, setShowCollectionForm] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  const isServiceProvider = userRoles.includes('ServiceProvider');
  const isAdmin = userRoles.includes('admin');

  // Tab configuration matching Students.jsx pattern
  const paymentTabs = [
    { key: 'collection', label: 'Collection', color: '#2196f3' },
    { key: 'approval', label: 'Approval', color: '#10b981' }
  ];

  // Access control
  if (!isServiceProvider && !isAdmin) {
    return (
      <div className="access-denied-container">
        <h2>Access Denied</h2>
        <p>This page is only accessible to instructors and administrators.</p>
      </div>
    );
  }

  const handleNewPayment = () => {
    setShowCollectionForm(true);
  };

  const handleCloseForm = () => {
    setShowCollectionForm(false);
  };

  const handlePaymentCreated = () => {
    setShowCollectionForm(false);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleApprovalAction = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="page-container">
      {/* Page Header - Matching Students.jsx structure 
      <div className="page-header">
        <div className="page-header-left">
          <CreditCard size={32} className="page-icon" />
          <h1 className="page-title">Payments</h1>
        </div>
      </div>
      */}
      {/* Status Tabs with Action Button */}
      <div className="status-tabs-with-action">
        <div className="status-tabs">
          {paymentTabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`status-tab ${activeTab === tab.key ? 'active' : ''}`}
              style={{
                '--tab-color': tab.color,
                borderBottomColor: activeTab === tab.key ? tab.color : 'transparent'
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
       
      </div>

      {/* Content Area - Matching Students.jsx structure */}
      <div className="page-content">
        {activeTab === 'collection' && !showCollectionForm && (
          <button onClick={handleNewPayment} className="btn-new">
            <Plus size={20} />
            New Payment
          </button>
        )}

        {activeTab === 'collection' && (
          showCollectionForm ? (
            <CollectionForm
              onClose={handleCloseForm}
              onPaymentCreated={handlePaymentCreated}
            />
          ) : (
            <div className="tab-content-placeholder">
              <h2>Payment Collection</h2>
              <p>Click "New Payment" to record a student payment.</p>
            </div>
          )
        )}

        {activeTab === 'approval' && (
          <ApprovalList
            refreshTrigger={refreshTrigger}
            onApprovalAction={handleApprovalAction}
          />
        )}
      </div>
    </div>
  );
};

export default Payments;